import React from "react";
import { useNavigate } from "react-router-dom";
import { Parallax } from "react-parallax";
import "../../styles/WallTiles.css";
import "../../styles/Parallax.css";
import img1 from "../../images/laminates/10mm/img1.jpg";
import img2 from "../../images/laminates/10mm/img2.jpg";
import img3 from "../../images/laminates/10mm/10mm.jpeg";
import img4 from "../../images/laminates/10mm/10mm 2.jpg";
import img5 from "../../images/laminates/10mm/10mm 3.jpg";

const Laminates10 = () => {
  const navigate = useNavigate();

  const images = [
    {
      url: img1,
      text: "Majestic",
      name: "Majestic Laminate",
      desc: "Click Image to See More",
    },
    {
      url: img2,
      text: "Mood",
      name: "Mood Laminate",
      desc: "Click Image to See More",
    },
    {
      url: img3,
      text: "Krono Marine",
      name: "Krono Marine Laminate",
      desc: "Click Image to See More",
    },
    {
      url: img4,
      text: "Krono Aroma",
      name: "Krono Aroma Laminate",
      desc: "Click Image to See More",
    },
    {
      url: img5,
      text: "Xtreme Wide & Long",
      name: "Xtreme Wide & Long Laminate",
      desc: "Click Image to See More",
    },
  ];

  const handleNavigate = (image) => {
    navigate(`/10mm_Laminate/${image.text}`, { state: { image } });
  };

  return (
    <>
      <div className="tile1">
        <div className="text">
          <div className="first">
            <p className="second">
              <h1>10mm Laminates</h1>
              Laminate wood flooring is a cost-effective alternative to
              hardwood, offering the look of natural wood at a fraction of the
              price. It is highly durable and resistant to scratches, stains,
              and moisture, making it ideal for high-traffic areas and homes
              with pets or children. Easy to install with click-and-lock
              systems, it reduces labor costs and installation time. Laminate
              flooring requires minimal maintenance and is simple to clean,
              making it a practical choice for busy households. Its wide range
              of designs, colors, and textures ensures it can mimic various wood
              types, offering versatility for different interior styles.
            </p>
            <div>
              <img src={img1} alt="10mm Laminate Tile" className="main_image" />
            </div>
          </div>
        </div>
      </div>

      <div>
        {images.map((image, index) => (
          <Parallax
            key={index}
            bgImage={image.url}
            strength={300}
            bgImageStyle={{
              width: "100%",
              height: "100%",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div
              className={`section section-${index + 1}`}
              onClick={() => handleNavigate(image)}
              key={index}
              style={{ cursor: "pointer" }}
            >
              <div className="text-overlay">
                <h2>{image.text}</h2>
                <p >{image.desc}</p>
              </div>
             
            </div>
          </Parallax>
        ))}
      </div>
    </>
  );
};

export default Laminates10;
